import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, apiError } from '../../lib/api';

const PILL = {
  planned: { cls: 'pill-pending', label: 'Planned' },
  completed: { cls: 'pill-approved', label: 'Completed' },
  no_response: { cls: 'pill-rejected', label: 'No response' },
  follow_up: { cls: 'pill-in_progress', label: 'Follow-up' },
};

export default function OwnerVisits() {
  const [visits, setVisits] = useState([]);
  const [err, setErr] = useState('');

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get('/owner/visits'); setVisits(data.visits || []); }
      catch (e) { setErr(apiError(e)); }
    })();
  }, []);

  return (
    <div data-testid="owner-visits">
      <h2 className="mb-3">Employee visits to my businesses</h2>
      <p className="text-muted-2 small">Sales & support employees log every visit here so you can see exactly what happened and when.</p>
      {err && <div className="alert alert-danger">{err}</div>}
      {visits.length === 0 ? (
        <div className="ap-card">No employee visits recorded yet.</div>
      ) : (
        <div className="row g-3">
          {visits.map(v => (
            <div className="col-md-6" key={v.id}>
              <div className="ap-card" data-testid={`ov-${v.id}`}>
                <div className="d-flex justify-content-between">
                  <div>
                    <div className="fw-bold">{v.business_name}</div>
                    <div className="small text-muted-2">by <strong>{v.employee_name}</strong> · {new Date(v.created_at).toLocaleString()}</div>
                  </div>
                  <span className={'pill ' + (PILL[v.status]?.cls || 'pill-disabled')}>{PILL[v.status]?.label || v.status}</span>
                </div>
                {v.purpose && <div className="small mt-2"><strong>Purpose:</strong> {v.purpose}</div>}
                {v.notes && <p className="small mt-1 mb-2">{v.notes}</p>}
                {v.next_follow_up && <div className="small">📅 Next follow-up: {new Date(v.next_follow_up).toLocaleString()}</div>}
                <div className="d-flex gap-2 mt-2 flex-wrap">
                  {v.latitude && v.longitude && <a className="btn-ap-outline btn-sm" href={`https://maps.google.com/?q=${v.latitude},${v.longitude}`} target="_blank" rel="noreferrer" data-testid={`ov-map-${v.id}`}>Location</a>}
                  {v.photo_url && <a className="btn-ap-outline btn-sm" href={(process.env.REACT_APP_BACKEND_URL || '') + v.photo_url} target="_blank" rel="noreferrer" data-testid={`ov-photo-${v.id}`}>Photo</a>}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="mt-3"><Link to="/owner" className="btn-ap-outline">← Back to dashboard</Link></div>
    </div>
  );
}
